<template>
  <span>
    <v-btn @click.stop="setDialog(true)" class="ma-1" color="red" outlined x-small>Delete</v-btn>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <delete-confirmation :pack="pack" @setDialog="setDialog"></delete-confirmation>
    </v-dialog>
  </span>
</template>

<script>
import DeleteConfirmation from "./PackDeleteConfirmation";

export default {
  components: { DeleteConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    pack: { required: true, type: Object },
  },
};
</script>
